import { CheckboxProps } from "@/types/component"

import "./index.scss"

import React from "react"

/**
 * Ortak onay kutusu.
 *
 * Tik işaretini artık bu bileşen değil `index.scss`'teki global
 * `input[type="checkbox"]:checked` kuralı çiziyor. Önceden tik burada bir React
 * ikonu olarak duruyordu ve `value` alanına bakıyordu; sonuç olarak
 *  - ham `<input type="checkbox">` kullanan ekranlarda tik hiç görünmüyordu
 *    (global kural `appearance: none` verip tarayıcının tikini kaldırıyor),
 *  - `value` yerine `checked` gönderen çağrılarda kutu işaretli olmasına rağmen
 *    tik çizilmiyordu.
 *
 * CSS'e taşındığı için tik her koşulda elemanın GERÇEK işaretli durumunu
 * gösterir.
 */
export const Checkbox: React.FC<CheckboxProps> = ({
  checked,
  disabled,
  label,
  value,
  bordered = false,
  ...props
}) => {
  return (
    <div className={`checkbox-with-text ${bordered ? "bordered" : ""}`}>
      <label className={`label ${disabled ? "disabled" : ""}`}>
        <input
          // `value` bu bileşenin asıl alanı; `checked` geriye dönük olarak
          // kabul ediliyor. İkisi de verilmediyse kontrolsüz input olmasın diye
          // false'a düşülür.
          checked={value ?? checked ?? false}
          className="checkbox"
          disabled={disabled}
          type="checkbox"
          {...props}
        />
        {label}
      </label>
    </div>
  )
}
